module.exports = __webpack_public_path__ + "img/02.91c4b3a6.png";